/**
 * Thin GA4 wrapper. Safe to call before gtag.js loads (no-op).
 *
 * Usage:
 *   import { track } from "@/lib/analytics";
 *   track("text_gutters_click", { location: "hero" });
 *
 * Events wired in the app:
 *   - text_gutters_click  { location }
 *   - phone_call_click    { location }
 *   - form_submit         { service_type }
 *   - chat_opened         { trigger: "auto" | "manual" }
 *   - quote_generated_by_gage { service_type, total }
 */

export function track(eventName, params = {}) {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.gtag !== "function") return;
    // transport: 'beacon' ensures the event still ships on outbound navigation
    // (sms:/tel: links, page unload, etc.)
    window.gtag("event", eventName, {
      transport_type: "beacon",
      ...params,
    });
  } catch {
    /* never let analytics break the UI */
  }
}
